<section>
  <div class="">
    <div class="row container-style mb-2">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-between align-items-center p-2">
        <div class="d-flex gap-4 ps-2">
          <div>
            <label class="text-muted small d-block">Equipo</label>
            <span class="fw-bold">
              {{articleObject.code == 0 ? '' : articleObject.code }}
            </span>
          </div>
          <div>
            <label class="text-muted small d-block">Cód. Alt.</label>
            <span class="fw-bold">
              {{articleObject.alterCode}}
            </span>
          </div>
          <div>
            <label class="text-muted small d-block">Nombre</label>
            <span class="fw-bold text-uppercase">
              {{articleObject.name}}
            </span>
          </div>
        </div>
        <app-custom-button *ngIf=" this.activeTabIndex === 0" [label]="'Agregar Insumos'" [icon]="'pi pi-plus'"
          [severity]="'success'" [disabled]="!disabledActions" [width]="'10rem'" [variant]="undefined"
          (onClick)="addSupplies()"></app-custom-button>

        <app-custom-button *ngIf=" this.activeTabIndex !== 0" [label]="'Agregar Homólogos'" [icon]="'pi pi-plus'"
          [width]="'10rem'" [disabled]="!disabledActions || mainArticleId === 0" [variant]="undefined"
          (onClick)="openHomologousModal()"></app-custom-button>

        <app-custom-modal #homologousModal [label]="'Selección Homólogos'" [header]="'Selección Homólogos'"
          [children]="componentHomologous" [inputs$]="inputsForHomologous$" [output$]="output$" [width]="'70vw'"
          (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
      </div>
    </div>
    <p-tabs value="{{activeTabIndex}}" class="custom-tabs container-style">
      <p-tablist style="display: flex; align-items: center;">
        <p-tab (click)="handleTabChange(0)" value="0">Insumos</p-tab>
        <p-tab (click)="handleTabChange(1)" value="1" [disabled]="mainArticleId === 0">
          {{labelHomologous}}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="container-style row mx-0" [hidden]="!isFormView">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
              <app-register-maintenance-routine-supply [maintenanceRoutineContract]="maintenanceRoutineModel"
                [maintenanceRoutineSupplyContract]="maintenanceRoutineSupplyModel" [disabled]="disabledActions"
                (updateListDetail)="getMaintenanceRoutineSuppliesWithPagination()" (isFormView)="getFormView($event)">
              </app-register-maintenance-routine-supply>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
            <app-custom-table [headers]="columns" [data]="data" [actions]="tableActions"
              [showCheckbox]="this.disabledActions" [checkBoxAction]="checkboxActions"
              (onRecoverData)="getMaintenanceRoutineSuppliesWithPagination()" (onPageChange)="onPageChange($event)"
              (onAction)="onAction($event)">
            </app-custom-table>
          </div>
        </p-tabpanel>
        <p-tabpanel value="1">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12 ">
            <app-custom-table [headers]="columnsHomologous" [data]="dataHomologous"
              [showCheckbox]="this.disabledActions" [checkBoxAction]="checkboxActions"
              (onRecoverData)="getHomologousByMainArticle()" (onPageChange)="onPageChange($event)"
              (onAction)="onAction($event)">
            </app-custom-table>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</section>